/* Oxalis — shop toolbar (collection + search).
   Category chips, then "Couleur / Signification / Fleur" (+ Prix) as compact
   dropdown triggers, and "Trier par" — all always visible directly on the
   page, on every breakpoint. No "Filtrer" button, no drawer: each dropdown
   opens its own panel (floating on desktop, inline full-width on mobile/
   tablet via CSS) and only one stays open at a time. Any change applies
   immediately. Grid, active chips, result count and pagination update via
   the Section Rendering API — no full page reload. */
(function () {
  'use strict';

  var container = document.querySelector('[data-collection], [data-search-results]');
  var sectionId = (container && container.getAttribute('data-section-id')) || null;

  function host() {
    return document.querySelector('[data-facets]');
  }

  /* ---------- url / render ---------- */
  function buildUrlFromForm(form) {
    var params = new URLSearchParams(new FormData(form));
    var clean = new URLSearchParams();
    params.forEach(function (value, key) {
      if (value !== '' && value != null) clean.append(key, value);
    });
    return window.location.pathname + '?' + clean.toString();
  }

  function openFilterLabels() {
    var labels = [];
    var h = host();
    if (!h) return labels;
    h.querySelectorAll('[data-fdrop][open]').forEach(function (d) {
      var s = d.querySelector('.fdrop__btn span');
      if (s) labels.push(s.textContent.trim());
    });
    return labels;
  }
  function restoreOpen(labels) {
    if (!labels.length) return;
    var h = host();
    if (!h) return;
    h.querySelectorAll('[data-fdrop]').forEach(function (d) {
      var s = d.querySelector('.fdrop__btn span');
      if (s && labels.indexOf(s.textContent.trim()) !== -1) d.open = true;
    });
  }

  function render(url, opts) {
    opts = opts || {};
    var h = host();
    if (h) h.setAttribute('aria-busy', 'true');
    var reopen = opts.keepOpen ? openFilterLabels() : [];

    var fetchUrl = url;
    if (sectionId) {
      fetchUrl += (url.indexOf('?') === -1 ? '?' : '&') + 'section_id=' + sectionId;
    }

    fetch(fetchUrl)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        swap(doc, '#product-grid');
        swap(doc, '[data-facets]');
        swap(doc, '.pagination');
        history.pushState({}, '', url);
        restoreOpen(reopen);
        bind();
        var nh = host();
        if (nh) nh.removeAttribute('aria-busy');
        if (opts.scroll) {
          var grid = document.querySelector('#product-grid');
          if (grid) grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      })
      .catch(function () { window.location.href = url; });
  }

  function swap(doc, selector) {
    var next = doc.querySelector(selector);
    var current = document.querySelector(selector);
    if (next && current) current.replaceWith(next);
    else if (!next && current) current.remove();
  }

  /* ---------- bindings ---------- */
  function bind() {
    var h = host();
    if (!h) return;

    var form = h.querySelector('[data-facets-form]');
    if (form && !form.dataset.bound) {
      form.dataset.bound = '1';
      // Applies immediately on every breakpoint, including mobile/tablet —
      // no "Appliquer" batching step.
      form.addEventListener('change', function (e) {
        if (e.target && e.target.matches('[data-fdrop-search]')) return;
        render(buildUrlFromForm(form), { keepOpen: true });
      });
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        render(buildUrlFromForm(form), { scroll: true });
      });
    }

    var sort = h.querySelector('[data-facets-sort]');
    if (sort && !sort.dataset.bound) {
      sort.dataset.bound = '1';
      sort.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sort.value);
        var hidden = h.querySelector('[data-facets-form-sort]');
        if (hidden) hidden.value = sort.value;
        render(url.pathname + url.search);
      });
    }

    h.querySelectorAll('[data-facets-clear]').forEach(function (el) {
      if (el.dataset.bound) return;
      el.dataset.bound = '1';
      el.addEventListener('click', function (e) {
        e.preventDefault();
        render(el.getAttribute('href'));
      });
    });

    h.querySelectorAll('[data-facets-remove]').forEach(function (el) {
      if (el.dataset.bound) return;
      el.dataset.bound = '1';
      el.addEventListener('click', function (e) {
        e.preventDefault();
        render(el.getAttribute('href'), { keepOpen: true });
      });
    });

    // in-dropdown search (Fleur / Signification, when there are many values)
    h.querySelectorAll('[data-fdrop-search]').forEach(function (input) {
      if (input.dataset.bound) return;
      input.dataset.bound = '1';
      input.addEventListener('input', function () {
        var q = input.value.trim().toLowerCase();
        var list = input.parentNode.querySelectorAll('.fdrop__item');
        list.forEach(function (li) {
          var label = li.getAttribute('data-label') || '';
          li.classList.toggle('is-hidden', q !== '' && label.indexOf(q) === -1);
        });
      });
    });

    // one dropdown open at a time + outside click closes it — on every
    // breakpoint (mobile/tablet now uses the same compact triggers as
    // desktop, just with an inline instead of floating panel).
    h.querySelectorAll('[data-fdrop]').forEach(function (d) {
      if (d.dataset.bound) return;
      d.dataset.bound = '1';
      d.addEventListener('toggle', function () {
        if (!d.open) return;
        h.querySelectorAll('[data-fdrop]').forEach(function (o) {
          if (o !== d) o.open = false;
        });
      });
    });
  }

  document.addEventListener('click', function (e) {
    var h = host();
    if (!h) return;
    if (e.target.closest('[data-fdrop]')) return;
    h.querySelectorAll('[data-fdrop][open]').forEach(function (d) { d.open = false; });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var h = host();
    if (!h) return;
    h.querySelectorAll('[data-fdrop][open]').forEach(function (d) { d.open = false; });
  });

  /* ---------- exact return from a product page ----------
     Going back from a product page to this collection is, in the browsers
     that support it (notably Safari, which is aggressive about this),
     usually a back/forward-cache restore: the browser thaws this exact
     document — DOM, scroll position, open filters, everything — with none
     of this script re-running. That native restoration is already exactly
     right and must not be touched.
     `justRestoredFromBfcache` exists only to stop the popstate handler
     above from firing right after such a restore and blowing the correct
     state away with a fresh AJAX re-render (some browsers do fire a
     popstate around a bfcache restore, even though nothing about the
     filters/sort actually changed). */
  var justRestoredFromBfcache = false;
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    justRestoredFromBfcache = true;
    window.setTimeout(function () {
      justRestoredFromBfcache = false;
    }, 0);
  });

  window.addEventListener('popstate', function () {
    if (justRestoredFromBfcache) return;
    render(window.location.pathname + window.location.search);
  });

  /* ---------- fallback for when bfcache isn't available ----------
     Some browsers (mobile Safari under memory pressure, for one) can
     evict a page from bfcache, which means going back reloads the
     collection fresh from the server. Filters/sort survive that on their
     own (they live in the URL, which Shopify renders from directly); only
     the scroll position needs a hand — saved just before leaving the page,
     restored once on arrival, and consumed immediately so a later, genuinely
     fresh visit to the same URL never jumps somewhere unexpected. */
  if (container) {
    var scrollKey = 'oxalis:collection-scroll:' + window.location.pathname + window.location.search;

    window.addEventListener('pagehide', function () {
      try {
        sessionStorage.setItem(scrollKey, String(window.scrollY));
      } catch (e) {
        /* storage unavailable — nothing to restore later, harmless */
      }
    });

    window.setTimeout(function () {
      var saved;
      try {
        saved = sessionStorage.getItem(scrollKey);
        sessionStorage.removeItem(scrollKey);
      } catch (e) {
        return;
      }
      if (saved === null) return;
      var y = parseInt(saved, 10);
      if (!isNaN(y)) window.scrollTo(0, y);
    }, 0);
  }

  bind();
})();
